import React from 'react';
import PropTypes from 'prop-types';

import DueMonthly from '../../common/MiniCart/funComp/desktopCart/dueMonthly';
import { getAPPID, getUrlName } from '../../common/Helpers';

import { isDisplayOneTimeCharges } from '../../common/MiniCart/MiniCartUtils';
import OneTimeChargesDiscounts from '../../common/MiniCart/redesign/component/OneTimeChargesDiscounts';

const MCartDueMonthly = (props) => {
  const { plansReferenceData, isCartVisible, depletionType } = props;
  const pathName = window?.location?.pathname || props?.location?.pathName;
  const currentPageName = getUrlName(pathName);
  const selectedSetupChoices = depletionType?.indexOf('O') > -1 ? 'Professional SetUp' : 'Self SetUp';
  const isOneTimeCharges = isDisplayOneTimeCharges(currentPageName, selectedSetupChoices);

  return (
    <>
      <DueMonthly {...props} />

      {isCartVisible && <OneTimeChargesDiscounts plansReferenceData={plansReferenceData} isOneTimeCharges={isOneTimeCharges} appId={getAPPID()} />}
    </>
  );
};

export default MCartDueMonthly;

MCartDueMonthly.propTypes = {
  plansReferenceData: PropTypes.object,
  isCartVisible: PropTypes.bool,
  location: PropTypes.object,
  depletionType: PropTypes.string,
};
